import {
  ACTION_EMULATE_PAYMENT,
  ACTION_GET_CARD_OWNER_INFO,
  ACTION_GET_CATALOG,
  ACTION_GET_CONFIGURATION,
  ACTION_GET_ORDER,
  ACTION_REDIRECT_REFILL,
  ACTION_REFRESH_CATALOG,
  ACTION_REGISTER_BEGIN_PURCHASE,
  ACTION_REDIRECT,
  ACTION_GET_CARD_INFO,
  ACTION_CARDS_HISTORY,
  ACTION_CARDS_TARIFICATIONS,
  ACTION_CARDS_SUBSCRIPTIONS,
  ACTION_LOAD_DOC,
  ACTION_GET_IMAGES,
  ACTION_LOAD_STATIC_IMAGES
} from '@/store/const-actions.js';
import {
  MUTATION_CATALOG_SET,
  MUTATION_CONFIGURATION_SET,
  MUTATION_ORDER_SET,
  MUTATION_PHONE_SET,
  MUTATION_EMAIL_SET,
  MUTATION_IMAGES_SET,
  MUTATION_CONFIG_STATIC_IMAGES,
  MUTATION_SET_IMAGES_VERSION,
  MUTATION_CARDS_SET_CARD_HISTORY,
  MUTATION_CARDS_SET_CARD_TARIFICATIONS,
  MUTATION_CARDS_SET_CARD_SUBSCRIPTIONS

} from '@/store/const-mutations.js';
import {
  getDataForBeginPurchase,
  getEmptyOrder
} from '@/store/module-data-func.js';

import { api } from '@/api/api.js';
import { processActionAsync } from '@/store/process-action.js';
import token from '@/shared/token.js';
import { isoDate } from '@/tools/format';
import { getEMailFromStorage } from '@/shared/storage-email';
import { notEmptyStr } from '@/tools/rules';

export const actions = {
  async [ACTION_GET_CONFIGURATION] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const result = await api.configuration();

      context.commit(MUTATION_CONFIGURATION_SET, result.data);
      context.commit(MUTATION_ORDER_SET, getEmptyOrder());
      return result.data;
    });
  },

  async [ACTION_GET_CARD_OWNER_INFO] (context, payload) {
    let resultEmail = getEMailFromStorage();
    let resultPhone = null;
    try {
      const cardNum = context.state.configuration.cardNum;
      if (!cardNum) 
        return;
      try {
        const result = await api.cardOwner(cardNum);
        if (notEmptyStr(result.data.email)) 
          resultEmail = result.data.email;
        resultPhone = result.data.phone;
        return result;
      } 
      catch (error) {
        /* eslint-disable no-empty */
      }
    } 
    finally {
      context.commit(MUTATION_EMAIL_SET, { email: resultEmail });
      context.commit(MUTATION_PHONE_SET, { phone: resultPhone });
    }
  },

  async [ACTION_GET_CARD_INFO] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const response = await api.cardInfo(payload.card);
      return response.data;
    });
  },

  async [ACTION_CARDS_HISTORY] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const response = await api.cardInfoHistory(payload.card);
      context.commit(MUTATION_CARDS_SET_CARD_HISTORY, response.data);
      return response.data;
    });
  },

  async [ACTION_CARDS_SUBSCRIPTIONS] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const response = await api.cardInfoSubscriptions(payload.card);
      context.commit(MUTATION_CARDS_SET_CARD_SUBSCRIPTIONS, response.data);
      return response.data;
    });
  },

  async [ACTION_CARDS_TARIFICATIONS] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const response = await api.cardInfoTarifications(payload.card);
      context.commit(MUTATION_CARDS_SET_CARD_TARIFICATIONS, response.data);
      return response.data;
    });
  },

  async [ACTION_REDIRECT] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const ref = payload.link;
      window.location = ref;
    });
  },

  async [ACTION_REDIRECT_REFILL] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const backUrl = encodeURIComponent(window.location.href);
      const ref = `${context.state.configuration.refillPageUrl}/?card=${context.state.configuration.cardNum}&sum=${payload.sum}&backurl=${backUrl}`;
      window.location = ref;
    });
  },

  async [ACTION_GET_CATALOG] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      await context.dispatch(ACTION_GET_CARD_OWNER_INFO);

      const { posId, t2PPosId } = context.state.configuration;

      const usedPosId = posId ?? t2PPosId; 

      const result = await api.getCatalog(usedPosId, isoDate(context.state.visitDate));

      context.commit(
        MUTATION_CATALOG_SET,
        result.data.map((item) => ({ ...item, qnt: 0 }))
      );

      return result;
    });
  },

  async [ACTION_REFRESH_CATALOG] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      await context.dispatch(ACTION_GET_CARD_OWNER_INFO);
      
      const { posId, t2PPosId } = context.state.configuration;

      const usedPosId = posId ?? t2PPosId; 

      const result = await api.getCatalog(usedPosId, isoDate(context.state.visitDate));

      context.commit(
        MUTATION_CATALOG_SET,
        result.data.map((item) => ({ ...item, qnt: 0 }))
      );
      return result;
    });
  },

  async [ACTION_REGISTER_BEGIN_PURCHASE] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const dataForBeginPurchase = getDataForBeginPurchase(context, payload.payByClubCard, payload.payBySpb);
      const result = await api.registerBeginPurchase(dataForBeginPurchase.data);
      // token.saveGkId(result.data.gkId);
      // Если это заглушка для отладки, перенаправляем на страницу заглушки
      // if (context.state.configuration.urlToPayService.toUpperCase() === 'DEBUG_DUMMY') {
      //   router.push(`/pay-service-emulation?gkId=${token.getGkId()}&amount=${dataForBeginPurchase.orderSum * 100}`);
      // }
      // else {
      const ref = `${result.data.url}`;
      window.location = ref;
      // }
    });
  },

  async [ACTION_EMULATE_PAYMENT] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const saleInfo = context.state.saleInfo;
      const sum = saleInfo.qnt * saleInfo.price;
      const result = await api.emulatePayment(token.getGkId(), sum * 100);
      context.commit(MUTATION_ORDER_SET, result.data);
    });
  },

  async [ACTION_GET_ORDER] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const orderId = payload.orderId ? payload.orderId : token.getGkId();
      const result = await api.getOrder(orderId);
      context.commit(MUTATION_ORDER_SET, result.data);
      return result;
    });
  },

  async [ACTION_LOAD_DOC] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const result = await api.getDoc(payload.documentName);
      return result;
    });
  },

  async [ACTION_LOAD_STATIC_IMAGES] (context, payload) {
    return await processActionAsync(context, payload, async function () {
      const result = await api.getStaticImages();

      context.commit(MUTATION_CONFIG_STATIC_IMAGES, result);
      return result;
    });
  },
  
  async [ACTION_GET_IMAGES] (context) {
    const savedVersion = localStorage.getItem('imagesVersion');
    const cachedVersion = savedVersion ? Number(savedVersion) : 0;
    
    if (cachedVersion && context.state.configuration.images.length === 0) {
      const savedImages = localStorage.getItem('imagesData');
      if (savedImages) {
        context.commit(MUTATION_IMAGES_SET, JSON.parse(savedImages));
      }
    }

    const response = await api.getImages();
    const { version, images } = response;

    if (String(version) === String(cachedVersion) && context.state.configuration.images.length > 0) {
      return context.state.configuration.images;
    }

    await Promise.all(images.map(img => new Promise(resolve => {
      const image = new Image();
      image.onload = resolve;
      image.onerror = resolve;
      image.src = img.url;
    })));

    context.commit(MUTATION_IMAGES_SET, images);
    context.commit(MUTATION_SET_IMAGES_VERSION, version);

    localStorage.setItem('imagesVersion', version.toString());
    localStorage.setItem('imagesData', JSON.stringify(images));

    return images;
  }
};
